import { USER_ROLES } from 'constants/userRoles';

export const adaptUserData = (data) => {
  if (data.role === USER_ROLES.company) {
    return { ...data, role: 'Brokerage Admin' };
  }
  return data;
};
